import React from "react";
import Image from "next/image";
export default function Priyanka({ quote }) {
  return (
    quote && (
      <div className="py-20 flex md:flex-row flex-col items-center lg:gap-20 gap-8 mx-auto w-full">
        <div className="md:w-[423px] w-full h-[281px] relative shrink-0">
          <Image
            src={"/images/priyanka.webp"}
            alt="about banner"
            sizes="(max-width: 479px) 500px, 500px"
            fill
            className="w-full h-full object-cover object-bottom bg-[#E9E7DE]"
          />
        </div>
        <div className="w-full flex flex-row gap-2 relative lg:max-w-[616px]">
          <div className="w-[60px] h-[60px] relative -translate-y-4 lg:translate-x-4">
            <Image
              src={"/images/icons/quote-mini.svg"}
              alt="about banner"
              sizes="(max-width: 479px) 500px, 100vw"
              fill
              className="w-full h-full object-contain"
            />
          </div>
          <div className="flex flex-col gap-8 pr-4 md:pr-8">
            {/* <div
              className="font-light font-havletica lg:[&>p]:text-2xl [&>p]:text-lg [&>*]:leading-tight text-[#333333]/80"
              dangerouslySetInnerHTML={{ __html: quote }}
            ></div> */}

            <div
          className="font-light font-havletica lg:[&>p]:text-2xl [&>p]:text-lg [&>*]:leading-tight text-[#333333]/80"
          dangerouslySetInnerHTML={{
            __html: quote.replace(/<h5[^>]*>(.*?)<\/h5>/gi, '$1'),
          }}
        ></div>
            <div className="flex flex-col items-end justify-center border-r-[0.5px] border-darkGrey/50 px-6">
              <p className="lg:text-2xl text-lg font-havletica font-light text-[#333333]/80 ">
                Priyanka Singh
              </p>
              <p className="text-[12px] text-darkGrey">Studio Head</p>
            </div>
          </div>
        </div>
      </div>
    )
  );
}
